/**
 * Porównanie etykiet edycji UD (np. "2020", "2025") — rosnąco, chronologicznie.
 */
export function compareUdEditionLabelsChronological(a, b) {
   const s1 = String(a ?? "").trim();
   const s2 = String(b ?? "").trim();
   const n1 = parseInt(s1, 10);
   const n2 = parseInt(s2, 10);
   if (!Number.isNaN(n1) && !Number.isNaN(n2)) return n1 - n2;
   return s1.localeCompare(s2, "pl", { numeric: true });
}

/**
 * Permutacja indeksów [0, 1] zgodna z API (0 = pierwsza wybrana edycja, 1 = druga),
 * tak aby wizualna kolejność (słupki / legenda) była od najwcześniejszej do najpóźniejszej.
 */
export function udCompareEditionApiIndexOrder(edition1, edition2) {
   const labels = [edition1, edition2];
   return [0, 1].sort((i, j) =>
      compareUdEditionLabelsChronological(labels[i], labels[j])
   );
}
